import React from 'react'

export const GeneralGuideIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_1477_1506)'>
      <path
        d='M10 0.5C15.2467 0.5 19.5 4.75329 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.75329 4.75329 0.5 10 0.5Z'
        stroke='#0F172A'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.2456 5.75781L12.4416 11.1688C12.3434 11.4634 12.178 11.7311 11.9584 11.9506C11.7389 12.1702 11.4712 12.3356 11.1766 12.4338L5.76562 14.2378L7.56962 8.82681C7.66781 8.53223 7.83323 8.26455 8.0528 8.04499C8.27237 7.82542 8.54004 7.66 8.83463 7.56181L14.2456 5.75781Z'
        stroke='#0F172A'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_1477_1506'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const DeveloperCenterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.0026 18.3385C4.56058 18.3385 4.13665 18.1629 3.82409 17.8504C3.51153 17.5378 3.33594 17.1139 3.33594 16.6719V3.33854C3.33594 2.89652 3.51153 2.47259 3.82409 2.16003C4.13665 1.84747 4.56058 1.67188 5.0026 1.67188H11.6693C11.9331 1.67145 12.1943 1.72321 12.438 1.82418C12.6818 1.92516 12.9031 2.07334 13.0893 2.26021L16.0793 5.25021C16.2666 5.43647 16.4152 5.658 16.5165 5.90201C16.6178 6.14603 16.6697 6.40769 16.6693 6.67188V16.6719C16.6693 17.1139 16.4937 17.5378 16.1811 17.8504C15.8686 18.1629 15.4446 18.3385 15.0026 18.3385H5.0026Z'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.6641 1.67188V5.83854C11.6641 6.05956 11.7519 6.27152 11.9081 6.4278C12.0644 6.58408 12.2764 6.67187 12.4974 6.67187H16.6641'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.33073 10C8.10972 10 7.89775 10.0878 7.74147 10.2441C7.58519 10.4004 7.4974 10.6123 7.4974 10.8333V11.6667C7.4974 11.8877 7.4096 12.0996 7.25332 12.2559C7.09704 12.4122 6.88508 12.5 6.66406 12.5C6.88508 12.5 7.09704 12.5878 7.25332 12.7441C7.4096 12.9004 7.4974 13.1123 7.4974 13.3333V14.1667C7.4974 14.3877 7.58519 14.5996 7.74147 14.7559C7.89775 14.9122 8.10972 15 8.33073 15'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.6641 15C11.8851 15 12.097 14.9122 12.2533 14.7559C12.4096 14.5996 12.4974 14.3877 12.4974 14.1667V13.3333C12.4974 13.1123 12.5852 12.9004 12.7415 12.7441C12.8978 12.5878 13.1097 12.5 13.3307 12.5C13.1097 12.5 12.8978 12.4122 12.7415 12.2559C12.5852 12.0996 12.4974 11.8877 12.4974 11.6667V10.8333C12.4974 10.6123 12.4096 10.4004 12.2533 10.2441C12.097 10.0878 11.8851 10 11.6641 10'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const UserCenterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.0026 10.8333C12.3038 10.8333 14.1693 8.96785 14.1693 6.66667C14.1693 4.36548 12.3038 2.5 10.0026 2.5C7.70142 2.5 5.83594 4.36548 5.83594 6.66667C5.83594 8.96785 7.70142 10.8333 10.0026 10.8333Z'
      stroke='black'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.6693 17.4948C16.6693 15.7267 15.9669 14.031 14.7166 12.7807C13.4664 11.5305 11.7707 10.8281 10.0026 10.8281C8.23449 10.8281 6.5388 11.5305 5.28856 12.7807C4.03832 14.031 3.33594 15.7267 3.33594 17.4948'
      stroke='black'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const PricingBillingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.8333 5.83333V3.33333C15.8333 3.11232 15.7455 2.90036 15.5893 2.74408C15.433 2.5878 15.221 2.5 15 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667C2.5 4.60869 2.67559 5.03262 2.98816 5.34518C3.30072 5.65774 3.72464 5.83333 4.16667 5.83333H16.6667C16.8877 5.83333 17.0996 5.92113 17.2559 6.07741C17.4122 6.23369 17.5 6.44565 17.5 6.66667V10M17.5 10H15C14.558 10 14.134 10.1756 13.8215 10.4882C13.5089 10.8007 13.3333 11.2246 13.3333 11.6667C13.3333 12.1087 13.5089 12.5326 13.8215 12.8452C14.134 13.1577 14.558 13.3333 15 13.3333H17.5C17.721 13.3333 17.933 13.2455 18.0893 13.0893C18.2455 12.933 18.3333 12.721 18.3333 12.5V10.8333C18.3333 10.6123 18.2455 10.4004 18.0893 10.2441C17.933 10.0878 17.721 10 17.5 10Z'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.5 4.17188V15.8385C2.5 16.2806 2.67559 16.7045 2.98816 17.0171C3.30072 17.3296 3.72464 17.5052 4.16667 17.5052H16.6667C16.8877 17.5052 17.0996 17.4174 17.2559 17.2611C17.4122 17.1049 17.5 16.8929 17.5 16.6719V13.3385'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const SupportContactIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.5 9.17187H5C5.44203 9.17187 5.86595 9.34747 6.17851 9.66003C6.49107 9.97259 6.66667 10.3965 6.66667 10.8385V13.3385C6.66667 13.7806 6.49107 14.2045 6.17851 14.5171C5.86595 14.8296 5.44203 15.0052 5 15.0052H4.16667C3.72464 15.0052 3.30072 14.8296 2.98816 14.5171C2.67559 14.2045 2.5 13.7806 2.5 13.3385V9.17187ZM2.5 9.17187C2.5 8.18696 2.69399 7.21169 3.0709 6.30175C3.44781 5.39181 4.00026 4.56501 4.6967 3.86857C5.39314 3.17213 6.21993 2.61969 7.12987 2.24278C8.03982 1.86587 9.01509 1.67188 10 1.67188C10.9849 1.67187 11.9602 1.86587 12.8701 2.24278C13.7801 2.61969 14.6069 3.17213 15.3033 3.86857C15.9997 4.56501 16.5522 5.39181 16.9291 6.30175C17.306 7.21169 17.5 8.18696 17.5 9.17187M17.5 9.17187V13.3385C17.5 13.7806 17.3244 14.2045 17.0118 14.5171C16.6993 14.8296 16.2754 15.0052 15.8333 15.0052H15C14.558 15.0052 14.134 14.8296 13.8215 14.5171C13.5089 14.2045 13.3333 13.7806 13.3333 13.3385V10.8385C13.3333 10.3965 13.5089 9.97259 13.8215 9.66003C14.134 9.34747 14.558 9.17187 15 9.17187H17.5Z'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.5 13.3281V14.9948C17.5 15.8788 17.1488 16.7267 16.5237 17.3518C15.8986 17.9769 15.0507 18.3281 14.1667 18.3281H10'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const SupportCenterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.0026 18.3385C4.56058 18.3385 4.13665 18.1629 3.82409 17.8504C3.51153 17.5378 3.33594 17.1139 3.33594 16.6719V3.33854C3.33594 2.89652 3.51153 2.47259 3.82409 2.16003C4.13665 1.84747 4.56058 1.67188 5.0026 1.67188H11.6693C11.9331 1.67145 12.1943 1.72321 12.438 1.82418C12.6818 1.92516 12.9031 2.07334 13.0893 2.26021L16.0793 5.25021C16.2666 5.43647 16.4152 5.658 16.5165 5.90201C16.6178 6.14603 16.6697 6.40769 16.6693 6.67188V16.6719C16.6693 17.1139 16.4937 17.5378 16.1811 17.8504C15.8686 18.1629 15.4446 18.3385 15.0026 18.3385H5.0026Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10 14.1719H10.0083'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.58594 7.49884C7.78592 6.9477 8.17325 6.48437 8.68021 6.18986C9.18718 5.89535 9.78153 5.78839 10.3594 5.88767C10.9372 5.98696 11.4618 6.28617 11.8413 6.73301C12.2209 7.17985 12.4314 7.74589 12.4359 8.33217C12.4359 9.99884 9.93594 10.8322 9.93594 10.8322'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
